import { serviceUrl } from '../config/net.config'
//baseUrl2调用的是wtbu_service中的方法
import request from '@/utils/request'
// import qs from 'qs'

/**
 *  根据 id 查询大学生医保详情
 * @param id 
 * @returns 
 */
export function queryInsuranceInfoByUserid(data) {
    return request({
      url: serviceUrl+'/api/MedicelInsurance/queryMedicelInsuranceInfoByUserId?userId='+data,
      // head: 'application/json;charset=UTF-8',
      method: 'get',
      token:sessionStorage.getItem('xzztcToken')
    })
} 